import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'

interface TableProps {
  header: string
  tableHeaderCell: string[]
  tableBodyCell: React.ReactNode[]
}

function SimpleTable(props: TableProps) {
  const { header, tableHeaderCell, tableBodyCell } = props

  return (
    <TableContainer sx={{ height: '50vh' }}>
      <Typography variant='h4'> {header}</Typography>
      <Table aria-label='simple table'>
        <TableHead>
          <TableRow>
            {tableHeaderCell.map((cell, index) => (
              <TableCell
                key={cell}
                align={index === 0 ? 'left' : 'center'}
                sx={{
                  color: 'primary.dark',
                  fontSize: '16px'
                }}
              >
                {cell}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableBodyCell.map((bodyContent, index) => (
            <TableRow key={`bodyContent-${index}`}>{bodyContent}</TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default SimpleTable
